/* RHB facelift (mobile). Only moves and labels existing elements; no text, heading or link is changed. */
(function () {
  if (!window.matchMedia) return;
  var mq = window.matchMedia('(max-width: 749px)');
  /* pages with the title band (services, about, works, contact) get the layout at every width; elsewhere only on phones */
  if (!mq.matches && !document.querySelector('.rhx-band')) { if (mq.addEventListener) mq.addEventListener('change', function f(e) { if (e.matches) { mq.removeEventListener('change', f); run(); } }); return; }
  run();
  function run() {
  if (window.__rhxDone) return;
  window.__rhxDone = true;
  var d = document;
  function q(s, r) { return (r || d).querySelector(s); }
  function qa(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function txt(e) { return (e && e.textContent || '').replace(/\s+/g, ' ').trim(); }
  function wrap(e) { var p = e.parentElement; return (p && p.classList.contains('shg-box-vertical-align-wrapper')) ? p : e; }
  function el(tag, cls) { var e = d.createElement(tag); if (cls) e.className = cls; return e; }
  var band = q('.rhx-band');
  var path = location.pathname.replace(/\/$/, '');

  /* active chip in the service nav */
  qa('.rhx-band--service ~ .rte .shg-c-lg-3 a.shg-btn').forEach(function (a) {
    try { if (new URL(a.getAttribute('href'), location.href).pathname.replace(/\/$/, '').toLowerCase() === path.toLowerCase()) a.classList.add('rhx-on'); } catch (e) {}
  });

  /* chips row: keep the section label outside the swipe area, start the row at the current page */
  qa('.rhx-band--service ~ .rte .shg-c-lg-3 .shg-box-content').forEach(function (row) {
    var hc = qa(':scope > .shg-c', row).filter(function (c) { return c.querySelector('.shogun-heading-component'); })[0];
    if (hc) row.parentNode.insertBefore(hc, row);
    /* Barber always last in the hair-services chips */
    qa(':scope > .shg-c', row).filter(function (c) { var a = c.querySelector('a.shg-btn'); return a && /barber-aventura/i.test(a.getAttribute('href') || ''); }).forEach(function (c) { row.appendChild(c); });
    var on = q('a.shg-btn.rhx-on', row);
    if (on) { var w = on.closest('.shg-btn-wrapper') || on; var x = w.getBoundingClientRect().left - row.getBoundingClientRect().left + row.scrollLeft - 16; if (x > 0) row.scrollLeft = x; }
  });

  /* price tables: drop empty ones, keep "**" notes inside the card */
  qa('.rhx-band--service ~ .rte .shogun-table-wrapper').forEach(function (w) {
    var blk = w.closest('.shg-c');
    if (!txt(w)) { if (blk && !blk.querySelector('.rhx-menuhead')) blk.remove(); else w.remove(); }
  });
  /* first price group with its own title: photos and "Menu." go above the title, so the title stays the top of its card */
  qa('.rhx-band--service ~ .rte .shg-c-lg-9 .rhx-menuhead').forEach(function (mh) {
    var blk = mh.closest('.shg-c'); if (!blk) return;
    var prev = blk.previousElementSibling;
    while (prev && !prev.classList.contains('shg-c')) prev = prev.previousElementSibling;
    if (!prev || !prev.querySelector(':scope > .shogun-heading-component') || prev.querySelector('h1')) return;
    Array.prototype.slice.call(blk.children).forEach(function (c) {
      if (c.classList.contains('rhx-media') || c.classList.contains('rhx-menuhead')) prev.parentNode.insertBefore(c, prev);
    });
  });
  qa('.rhx-band--service ~ .rte .shg-c-lg-9 .shg-c').forEach(function (blk) {
    if (blk.closest('.shogun-table-wrapper') || blk.querySelector('.shg-c, .shogun-table-wrapper, .shogun-heading-component, h1, img')) return;
    if (!blk.querySelector('.shg-rich-text')) return;
    var t = txt(blk);
    if (!t) return;
    var next = blk.nextElementSibling, prev = blk.previousElementSibling;
    while (next && !next.classList.contains('shg-c')) next = next.nextElementSibling;
    while (prev && !prev.classList.contains('shg-c')) prev = prev.previousElementSibling;
    var tw = next && (next.matches('.shogun-table-wrapper') ? next : next.querySelector('.shogun-table-wrapper'));
    if (/^\*/.test(t) && tw) {
      tw.parentNode.insertBefore(blk, tw.nextSibling);
      blk.classList.add('rhx-note');
      tw.style.paddingBottom = '6px';
    } else if (prev && (prev.matches('.shogun-table-wrapper') || prev.querySelector('.shogun-table-wrapper')) && t.length < 200) {
      blk.classList.add('rhx-endnote');
    }
  });
  qa('.rhx-band--service ~ .rte table.shogun-table tr').forEach(function (tr) { if (!txt(tr)) tr.style.display = 'none'; });
  /* all-caps page titles get tracked caps instead of the big serif */
  var pt = q('.rhx-band .main-page-title');
  if (pt && txt(pt) === txt(pt).toUpperCase() && /[A-Z]/.test(txt(pt))) pt.classList.add('rhx-caps');

  /* contact card */
  function card(src, opts) {
    var titles = qa('h2, .eq_contact_section-title', src);
    var t1 = titles.find(function (h) { return /RH BEAUTY/i.test(txt(h)); });
    var t2 = titles.find(function (h) { return /GET IN TOUCH/i.test(txt(h)); });
    var t3 = titles.find(function (h) { return h !== t1 && h !== t2; });
    if (!t1 || !t2) return null;
    var cc = el('div', 'rhx-cc');
    function block(h) { var b = h.closest('.shg-c') || h; return b === src ? h : b; }
    var b1 = block(t1); b1.classList.add('rhx-cc__t1'); cc.appendChild(b1);
    var hrs = qa('p, .eq_contact_section-text', src).filter(function (p) { return /^(Mon-Sat|Sunday)/i.test(txt(p)); });
    if (hrs.length) { var r = el('div', 'rhx-cc__row rhx-cc__row--clock'); var col = el('div'); hrs.forEach(function (p) { col.appendChild(p); }); r.appendChild(col); cc.appendChild(r); }
    var b2 = block(t2); b2.classList.add('rhx-cc__t2'); cc.appendChild(b2);
    var loc = qa('p, .eq_contact_section-text', src).find(function (p) { return /^Located at/i.test(txt(p)); });
    if (loc) { var rl = el('div', 'rhx-cc__row rhx-cc__row--pin'); rl.appendChild(loc); cc.appendChild(rl); }
    var mail = q('a[href^="mailto:"]', src);
    if (mail) { mail.classList.add('rhx-cc__row', 'rhx-cc__row--mail'); cc.appendChild(mail); }
    var tel = q('a[href^="tel:"]', src);
    if (!tel) {
      var w = d.createTreeWalker(src, NodeFilter.SHOW_TEXT, null);
      var n, hit = null;
      while ((n = w.nextNode())) { if (/\+1 \(305\) 912-5555/.test(n.nodeValue)) { hit = n; break; } }
      if (hit) {
        var host = hit.parentNode.tagName === 'SPAN' ? hit.parentNode : null;
        tel = el('a'); tel.href = 'tel:+13059125555';
        if (host) { host.parentNode.insertBefore(tel, host); tel.appendChild(host); }
        else { hit.parentNode.insertBefore(tel, hit); tel.appendChild(hit); }
      }
    }
    if (tel) { tel.classList.add('rhx-cc__row', 'rhx-cc__row--phone'); cc.appendChild(tel); }
    if (t3) { var b3 = block(t3); b3.classList.add('rhx-cc__t3'); cc.appendChild(b3); }
    var btn = q('a.shg-btn, a.eq_contact_section-btn, a.eq_btn', src);
    if (btn) { var bw = el('div', 'rhx-cc__btn'); bw.appendChild(btn.closest('.shg-btn-wrapper') || btn); cc.appendChild(bw); }
    return cc;
  }
  var isContact = path === '/pages/contactus';
  qa('.shogun-root .shg-box, .eq_contact_section-container').forEach(function (box) {
    if (box.closest('.rhx-cc') || box.querySelector('.rhx-cc')) return;
    var h = qa('h2, .eq_contact_section-title', box).filter(function (x) { return /GET IN TOUCH/i.test(txt(x)); })[0];
    if (!h) return;
    if (q('.shg-box', box) && qa('.shg-box', box).some(function (b) { return /GET IN TOUCH/i.test(txt(b)); })) return; /* innermost only */
    var cc = card(box);
    if (!cc) return;
    var anchor = wrap(box);
    anchor.parentNode.insertBefore(cc, anchor);
    anchor.classList.add('rhx-cc-src');
    for (var up = cc.parentElement; up && !up.classList.contains('shogun-root') && !up.classList.contains('rte'); up = up.parentElement) { if (up.classList.contains('shg-box')) up.style.setProperty('background-color', 'transparent', 'important'); }
  });

  /* hair extensions: community strip before the contact card */
  var comm = q('.rhx-community');
  var firstCard = q('.rte .rhx-cc');
  if (comm && firstCard) firstCard.parentNode.insertBefore(comm, firstCard);

  /* blank Shogun paragraphs (nbsp only) */
  qa('.rhx-band ~ .rte .shg-rich-text p').forEach(function (p) { if (!txt(p).replace(/ /g, '').trim() && !p.querySelector('img,a,input')) p.classList.add('rhx-blank'); });
  /* about gallery: lazy Shogun images inside the swipe row */
  qa('#s-3b39bc27-3a28-4e2e-a42d-fe3a3323e580 img[data-src]').forEach(function (i) { if (!i.getAttribute('src')) { i.src = i.getAttribute('data-src'); i.loading = 'lazy'; } });

  /* about: page class */
  if (path === '/pages/about-us') d.body.classList.add('rhx-about');
  if (path === '/pages/ourworks') d.body.classList.add('rhx-works');

  /* contact page: tag blocks so CSS can order them */
  if (isContact) {
    d.body.classList.add('rhx-contact');
    var map = { 's-27c12964': 'rhx-c-h1', 's-b5b9ca53': 'rhx-c-links', 's-ebe19520': 'rhx-c-loc', 's-2228dea6': 'rhx-c-addr', 's-23f6c8fd': 'rhx-c-form', 's-1b3893d3': 'rhx-c-pol-h', 's-8b43298d': 'rhx-c-pol', 's-1bf3acbf': 'rhx-c-pol2' };
    Object.keys(map).forEach(function (k) {
      var e = q('[id^="' + k + '"]');
      if (!e) return;
      var tgt = e;
      if (map[k] === 'rhx-c-form') tgt = wrap(e);
      tgt.classList.add(map[k]);
      var row = tgt.closest('.shg-row');
      if (row) row.classList.add('rhx-cform-row');
    });
  }
  }
})();
